import _isNil from 'lodash/isNil';

export function getBusinessProperty(property, key, fallBackToFirst = true) {
  if (typeof property === 'string' || _isNil(property)) {
    return property;
  }
  return property[key] || (fallBackToFirst ? Object.values(property)[0] : null);
}
